import { makeStyles } from '@material-ui/core/styles';

export const BasicRRMessageStyles = makeStyles(() => ({
  rrBackdrop: {
    zIndex: 10,
  },
  title: {
    marginBottom: '.20rem',
  },
  content: {
    fontWeight: 600,
    marginBottom: '.20rem',
    fontSize: '14px',
  },
  marginBottom: {
    marginBottom: '1.20rem',
  },
  advancedRRPageContent: {
    fontWeight: 600,
    marginBottom: '1.25rem',
  },
  advancedRRPageTitle: {
    marginBottom: '1.2rem',
  },
}));
